export default "__VITE_ASSET__8cfd8ad3__"